import React from 'react';
import { injectIntl } from 'react-intl';
import { Button } from 'react-bootstrap';

import CmsCarouselChildRow from './CmsCarouselChildRow';

class CmsCarouselChildren extends React.Component {
  render() {
    const { label, index, element, navigateSettings, addElement, removeElement, reorderElements } = this.props;

    return (
      <div class="form-group form-group-default">
        <label>{label}</label>
        <div style={{ position: 'relative' }}>
          {element.children !== undefined
            ? element.children.map((child, i) => {
                return (
                  <CmsCarouselChildRow
                    child={child}
                    navigateSettings={navigateSettings}
                    removeElement={removeElement}
                    reorderElements={reorderElements}
                    index={index + '.' + i}
                    key={i}
                  />
                );
              })
            : null}

          <div class="text-center p-t-15">
            <Button class="btn-rounded" onClick={() => addElement(index, { type: 'carousel_child' })}>
              <i class="fa fa-plus" />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default injectIntl(CmsCarouselChildren);
